(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function slug(t, used) {
    var s = t.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
    var base = s, n = 2;
    while (used[s] || document.getElementById(s)) s = base + '-' + n++;
    used[s] = true;
    return s;
  }

  function init(nav) {
    if (nav.hasAttribute('data-rj-ready')) return;
    var root = document.querySelector(nav.getAttribute('data-rj-root'));
    if (!root) return;
    var heads = Array.prototype.filter.call(root.querySelectorAll('h2'), function (h) {
      var b = h.nextElementSibling;
      return b && b.classList.contains('section-body') && h.textContent.trim();
    });
    if (heads.length < 4) return;
    nav.setAttribute('data-rj-ready', '');

    var menu = nav.querySelector('.rj-menu');
    var list = nav.querySelector('.rj-list');
    var cur = nav.querySelector('.rj-cur');
    var toggleAll = nav.querySelector('.rj-all');
    var used = {};
    var items = [];

    heads.forEach(function (h, i) {
      var label = h.textContent.trim();
      if (!h.id) h.id = slug(label, used);
      h.tabIndex = -1;
      h.classList.add('rj-h');
      var body = h.nextElementSibling;
      body.classList.add('rj-body');
      body.id = body.id || h.id + '-body';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rj-toggle';
      btn.setAttribute('aria-controls', body.id);
      btn.addEventListener('click', function () {
        if (MOBILE.matches) setOpen(i, btn.getAttribute('aria-expanded') !== 'true');
      });
      body.addEventListener('beforematch', function () { setOpen(i, true); });

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'rj-link';
      a.textContent = label;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(i, true);
        menu.open = false;
        h.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
        (MOBILE.matches ? btn : h).focus({ preventScroll: true });
      });
      li.appendChild(a);
      list.appendChild(li);
      items.push({ h: h, body: body, btn: btn, link: a, label: label });
    });

    function reduce() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setOpen(i, on) {
      var it = items[i];
      it.btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on || !MOBILE.matches) it.body.removeAttribute('hidden');
      else it.body.setAttribute('hidden', 'until-found');
      syncAll();
    }

    function syncAll() {
      if (!toggleAll) return;
      var allOpen = items.every(function (it) { return it.btn.getAttribute('aria-expanded') === 'true'; });
      toggleAll.textContent = allOpen ? 'Collapse all' : 'Expand all';
      toggleAll.setAttribute('data-open', allOpen ? '1' : '0');
    }

    function applyMode() {
      var hash = location.hash.slice(1);
      items.forEach(function (it, i) {
        if (MOBILE.matches) {
          if (it.btn.parentNode !== it.h) {
            while (it.h.firstChild) it.btn.appendChild(it.h.firstChild);
            it.h.appendChild(it.btn);
          }
          setOpen(i, it.h.id === hash);
        } else {
          if (it.btn.parentNode === it.h) {
            while (it.btn.firstChild) it.h.insertBefore(it.btn.firstChild, it.btn);
            it.h.removeChild(it.btn);
          }
          it.btn.setAttribute('aria-expanded', 'true');
          it.body.removeAttribute('hidden');
        }
      });
      if (toggleAll) toggleAll.hidden = !MOBILE.matches;
      syncAll();
    }

    if (toggleAll) {
      toggleAll.addEventListener('click', function () {
        var open = toggleAll.getAttribute('data-open') !== '1';
        items.forEach(function (it, i) { setOpen(i, open); });
      });
    }

    function setCurrent(n) {
      items.forEach(function (it, i) {
        if (i === n) it.link.setAttribute('aria-current', 'true');
        else it.link.removeAttribute('aria-current');
      });
      cur.textContent = n > -1 ? items[n].label : '';
    }

    function onScroll() {
      var line = nav.getBoundingClientRect().bottom + 24;
      var n = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].h.getBoundingClientRect().top <= line) n = i;
        else break;
      }
      setCurrent(n);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (menu.open && !menu.contains(e.target)) menu.open = false;
    });

    if (MOBILE.addEventListener) MOBILE.addEventListener('change', applyMode);
    applyMode();
    nav.hidden = false;
    onScroll();

    if (location.hash) {
      var t = document.getElementById(location.hash.slice(1));
      if (t && t.classList.contains('rj-h')) t.scrollIntoView({ block: 'start' });
    }
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rj]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
